export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14768.c5444ce9.jpg";